import React, { useContext, useEffect } from 'react';
import { AuthContext, AuthContextType } from 'Contexts/AuthContext';
import Login from './Login';

const LoginContainer = () => {
  const { signInUser, user } = useContext<AuthContextType>(AuthContext);

  return <Login onSignIn={signInUser} signInError={user.signInError} />;
};

export default LoginContainer;
